import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default class TextSwitcher extends React.Component {
  static propTypes = {
    value: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    onClick: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    const selected = props.options.find((o) => { return o.value === props.value });
    this.state = {
      selected,
    };
  }


  static getDerivedStateFromProps(nextProps, nextState) {
    if (nextProps.value !== nextState.value) {
      const selected = nextProps.options.find((o) => { return o.value === nextProps.value });
      return {
        selected,
      };
    }
    return null;
  }

  handleClick = (selected) => {
    const { onClick } = this.props;
    this.setState({
      selected
    }, () => onClick(selected.value));
  };

  render() {
    const { options } = this.props;
    const { selected } = this.state;

    return (
      <div className="switcher">
        {
          options.map((option) => (
            <div {...{
              key: option.text,
              className: classNames('pill', {
                'selected': option.value === selected.value,
              }),
              onClick: () => this.handleClick(option),
            }}>
              {option.text}
            </div>
          ))
        }
      </div>
    );
  }
}